import { Injectable } from '@angular/core';
import { UtilService } from '../util/util.service';
import { AudioService } from '../common/services/audio.service';
import { OrderReactEventService } from './order-reactevent.service';
import { ORDER_BY } from './platform.constant';

export function hasOrderTopup(order: any): boolean {
  return Number(order?.tvalue) > 0 || order?.topup_id === 'mm_topup';
}

@Injectable({
  providedIn: 'root',
})
export class OrderStateService {
  // If order is not of type auto accept then auto_accept_print_taken should be true so we dont match unnecessarily
  // To store order_id => (order_type,itr,notification_played,auto_accept_print_taken)
  currOrdersState = {};
  isKiosk: number;

  constructor(
    private _util: UtilService,
    private _orderEventService: OrderReactEventService,
    private _audioService: AudioService
  ) {
    this.isKiosk = this._util.isKiosk()
  }

  initOrderState(ordersInfo) {
    ordersInfo.forEach((order) => {
      let { order_id, order_type, order_status, itr } = order;
      !itr && (itr = 1);
      this.currOrdersState[order_id] = {
        order_id,
        order_type,
        order_status,
        itr,
        notification_played: true,
        print_taken: true,
      };
    });
  }

  // Gets Either Info From Pusher Notification or From Orders API
  // Order_id,ITR
  // 1. Notification Sound Play if there has been new order
  // 2. Print Orders that were auto accepted, either via pusher notification or orders api
  // 3. Update count badges on frontend
  updateOrdersState(newOrdersInfo, origin?: string, mtype?: string) {
    let toPlayNotify = false;
    let toTriggerPrint = [];
    let playedOrders = [];

    if (origin === 'from_pusher') {
      // If object not present, or if present but has older_itr, or present but notification_played,auto_accept_print_taken are set to false
      // Play sound
      // Print if triggerPrintEventForAutoAccept function criteria are met
      // Set value of notification_played,auto_accept_print_taken to true
      // Update itr to latest value
      // Ignoring badge count update as that is handled separatly

      let { order_id, order_type, order_status, itr, order_by } = (
        newOrdersInfo || {}
      ).data;
      !itr && (itr = 1);
      if (this.currOrdersState[order_id]) {
        if (this.currOrdersState[order_id].itr < itr) {
          toPlayNotify = true;
          playedOrders.push(order_id);
          this.currOrdersState[order_id].itr = itr;
        }

        if (
          mtype === 'OUP' &&
          order_type === 0 &&
          this.checkIfAutoAcceptEligible(order_type, order_status)
        ) {
          this.currOrdersState[order_id].print_taken = false;
        }
      } else {
        this.currOrdersState[order_id] = {
          order_id,
          order_type,
          order_status,
          itr,
          notification_played: false,
          print_taken: order_by === ORDER_BY.MM || order_by === ORDER_BY.MPOS,
        };
      }

      let orderObj = this.currOrdersState[order_id];
      if (!orderObj.notification_played) {
        toPlayNotify = true;
        playedOrders.push(order_id);
        orderObj.notification_played = true;
      }

      if (!orderObj.print_taken) {
        if (
          this.checkIfAutoAcceptEligible(
            orderObj.order_type,
            orderObj.order_status
          )
        ) {
          toTriggerPrint.push(orderObj);
        }
        orderObj.print_taken = true;
      }
    } else {
      if (Object.keys(this.currOrdersState).length === 0) {
        this.initOrderState(newOrdersInfo);
      } else {
        newOrdersInfo.forEach((order: any) => {
          if (this.currOrdersState[order.order_id]) {
            if (this.currOrdersState[order.order_id].itr < order.itr) {
              toPlayNotify = true;
              playedOrders.push(order.order_id);
              this.currOrdersState[order.order_id].itr = order.itr;

              let orderData = this.currOrdersState[order.order_id];
              if (
                orderData.order_type === 0 &&
                this.checkIfAutoAcceptEligible(
                  orderData.order_type,
                  orderData.order_status
                )
              ) {
                orderData.print_taken = false;
              }
            }
          } else {
            let { order_id, order_type, order_status, itr, order_by } = order;
            !itr && (itr = 1);
            this.currOrdersState[order_id] = {
              order_id,
              order_type,
              order_status,
              itr,
              notification_played: false,
              print_taken: order_by === ORDER_BY.AUTO,
            };
          }
          let orderObj = this.currOrdersState[order.order_id];
          // If notification played is false
          if (!orderObj.notification_played) {
            toPlayNotify = true;
            playedOrders.push(order.order_id);
            orderObj.notification_played = true;
          }

          // If print taken is false
          if (!orderObj.print_taken) {
            if (
              this.checkIfAutoAcceptEligible(
                orderObj.order_type,
                orderObj.order_status
              )
            ) {
              toTriggerPrint.push(orderObj);
            }
            orderObj.print_taken = true;
          }
        });
        // Manab to decide the logic here
        // let to_play_notify = false;
        // let notify_played = false;
        // for (order of newOrdersInfo){
        // Get OrderId
        // Get its state
        // let ostate = this.currOrdersState[oid];
        // If state doesn't exists
        //    Notification sound must be played either now or right after loop is complete
        //    If Printing is needed basis triggerPrintEventForAutoAccept function condition take a print

        // If state exists
        // Check if state has older_itr or notification_played,auto_accept_print_taken are set to false
        //    Notification sound must be played either now or right after loop is complete
        //    If Printing is needed basis triggerPrintEventForAutoAccept function condition take a print
      }
    }

    toPlayNotify && this._audioService.playAudioOnNewOrder();
    if(!this.isKiosk && this._util.getPrintFromDevice()){
      toTriggerPrint.forEach((order) =>
        this._util.sendPrintCommand(order.order_id, order.itr)
      );
    }
  }

  checkIfAutoAcceptEligible(orderType, orderStatus): boolean {
    return (
      this._orderEventService.autoAcceptOrderValue.enabled &&
      this._orderEventService.autoAcceptOrderValue.applicableOrderType.includes(
        orderType
      ) &&
      !(orderStatus === 11 || orderStatus === 12)
    );
  }

  filterAllRunningOrders(orders) {
      let ordersList = orders.filter((x) => {
        return (
          !(x.order_status === 4 || x.order_status === 11 || x.order_status === 12) && 
          (!(
            (x.order_type === 1 || (x.order_type === 2 && (x.table_no || '').toLowerCase() !== 'takeaway')) &&
            x.is_paid === 1  && x.order_by !== 'MM' && x.order_by !== 'auto'
          ) || x.pay_with_cash === 1 || hasOrderTopup(x))
        )
      });
      return ordersList;
  }
}
